const component = require('../component/component');

const numericInterval = Object.assign({}, component, {
    subelements: {
        slider: null,
    },
    min: 0,
    max: 100,
    handlesNo: 1,
    step: 1,
    displayPrefix: '',
    displaySuffix: '',
    noUiSlider: false,

    init: function () {
        component.init.call(this);

        this.createSlider();
    },

    createSlider: function () {
        let interval = this.getValue();

        let tooltips = [];

        interval.forEach((value) => {
            tooltips.push(true);
        });

        let connect = 'lower';

        if (this.handlesNo == 2) {
            connect = true;
        }

        let noUiSliderConfig = {
            start: interval,
            tooltips: tooltips,
            connect: connect,
            range: {
                min: this.min,
                max: this.max
            },
            format: {
                from: (value) => { 
                    return value;
                },
                to: (value) => {
                    return this.displayPrefix + value + this.displaySuffix;
                },
            },
            step: this.step
        };

        //this.hm.log('noUiSliderConfig', noUiSliderConfig);

        this.noUiSlider = noUiSlider.create(this.subelements.slider, noUiSliderConfig);

        this.noUiSlider.on('change', (values, handle, unencoded, tap, positions) => { this.setValue(unencoded); });
    },

    getValue: function () {
        let valueStr = component.getValue.call(this);

        return this.hm.helper.parseJson(valueStr);
    },

    setValue: function (values) {
        let value = [];

        for (let i = 0; i < values.length; i++) {
            value.push(parseInt(values[i]));
        }

        this.element.value = JSON.stringify(value);
    }
});


module.exports = numericInterval;